var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { StyledTabsWrapper, StyledTab, StyledContainer } from './style';
import Text from '../Text';
import Shimmer from '../ShimmerEffect';
var Tabs = function (_a) {
    var tabs = _a.tabs, _b = _a.value, value = _b === void 0 ? tabs[0].tabValue : _b, onChange = _a.onChange, disabledTab = _a.disabledTab, isLoading = _a.isLoading, _c = _a.justifyContent, justifyContent = _c === void 0 ? 'flex-start' : _c, margin = _a.margin, variant = _a.variant, _d = _a.showHeader, showHeader = _d === void 0 ? true : _d, props = __rest(_a, ["tabs", "value", "onChange", "disabledTab", "isLoading", "justifyContent", "margin", "variant", "showHeader"]);
    var renderLazyLoadingTabs = function (tabsNumber) {
        if (tabsNumber === void 0) { tabsNumber = 2; }
        var lazyLoading = function (index) { return (React.createElement(Shimmer.ShimmerEffect, { key: index },
            React.createElement(Shimmer.NoAnimationBox, { mx: 1, key: index },
                React.createElement(Shimmer.Rect, { width: 100, height: 35, borderRadius: 4 })))); };
        var loadingTabs = [];
        for (var counter = 0; counter < tabsNumber; counter += 1) {
            loadingTabs.push(lazyLoading(counter));
        }
        return loadingTabs;
    };
    var blockTabTextVariant = variant === 'block' ? 'smallText' : 'headlineBody';
    return (React.createElement(React.Fragment, null, isLoading ? (React.createElement(StyledTabsWrapper, { justifyContent: justifyContent, margin: margin }, renderLazyLoadingTabs(tabs.length))) : (React.createElement(StyledContainer, null,
        React.createElement(StyledTabsWrapper, { justifyContent: justifyContent, margin: margin, variant: variant }, tabs &&
            showHeader &&
            tabs.map(function (tab) { return (React.createElement(StyledTab, __assign({ onClick: function (event) {
                    if (tab.tabValue !== disabledTab) {
                        if (tab.onClick) {
                            tab.onClick(event);
                        }
                        onChange(tab.tabValue);
                    }
                }, isActiveTab: tab.tabValue === value, key: tab.name, id: tab.name, isDisabledTab: tab.tabValue === disabledTab, variant: variant, "data-testid": tab.tabValue === value ? 'active' : tab.name }, props),
                React.createElement(React.Fragment, null,
                    tab.prefix && tab.prefix,
                    React.createElement(Text, { variant: variant === 'category' ? 'body1' : blockTabTextVariant, cursor: tab.tabValue === disabledTab ? 'default' : 'pointer' }, tab.name)))); })),
        tabs &&
            tabs.map(function (tab) { return tab.tabValue === value && tab.component && React.createElement("div", { key: tab.name }, tab.component); })))));
};
export default Tabs;
